import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis,
  CartesianGrid, Tooltip, Legend, ResponsiveContainer,
  LineChart, Line, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar
} from 'recharts';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import api from '../../utils/api';
import {
  FiArrowLeft,
  FiTrendingUp,
  FiAward,
  FiTarget,
  FiBarChart2,
  FiBook,
  FiUsers,
  FiCheckCircle,
  FiXCircle,
  FiMinusCircle,
  FiClock,
  FiGrid,
  FiActivity,
  FiPieChart,
  FiFileText,
  FiHelpCircle,
  FiChevronRight
} from 'react-icons/fi';

const StudentOverall = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [performanceData, setPerformanceData] = useState(null);
  const [topStudents, setTopStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('overview');
  const [examLimit, setExamLimit] = useState("overall");
  const [examWiseData, setExamWiseData] = useState([]);
  const {
  overallStats = {},
  subjectWisePerformance = [],
  chapterWisePerformance = [],
  strongAreas = {},
  weakAreas = {},
  topicWisePerformance = [],
  studentInfo = {}
} = performanceData || {};

 useEffect(() => {
  const params = new URLSearchParams(window.location.search);

  const authToken = params.get("authToken");
  const staffId = params.get("staffId");
  const studentId = params.get("studentId");

  if (authToken && staffId && studentId) {
    localStorage.setItem("loggedInUser", authToken);
    localStorage.setItem("authToken", "kasejfksjdhfywterjwefbdskgfhsdfjh");
    localStorage.setItem("staffId", staffId);
    localStorage.setItem("studentId", studentId);

  }
}, []);

  async function fetchData() {
    try {
      setLoading(true);
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getStudentOverallPerformance";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("studentId", id);

      const response = await api.post("overView/overView", fd);
      console.log("Performance Data Response:", response.data);
      setPerformanceData(response.data.data);
    } catch (error) {
      console.error("Error fetching:", error);
    } finally {
      setLoading(false);
    }
  }

  async function fetchTopStudents() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "overallTopAndPoorStudents";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      const response = await api.post("overView/overView", fd);
      // console.log("Top Students Response:", response.data);
      setTopStudents(response.data.data.topStudents);
    } catch (error) {
      console.error("Error fetching:", error);
    }
  }

  async function fetchFilter(selectedLimit) {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getStudentsOverviewFromPaperLimit";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("studentId", id);
      fd.append("limit", selectedLimit);

      const response = await api.post("examPaper/exam", fd);
      // console.log("Filtered Exam Data:", response);

      if (response?.data) {
        setExamWiseData(response.data);
      }
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    }
  }

  useEffect(() => {
    fetchData();
    fetchTopStudents();
  }, [id]);

  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884D8', '#82CA9D'];
  const SUBJECT_COLORS = {
    'PUC I BIOLOGY': '#10B981',
    'PUC II CHEMISTRY': '#3B82F6',
    'PUC II PHYSICS': '#EF4444'
  };

  const getSubjectColor = (subjectName) => {
    if (subjectName.includes('BIOLOGY')) return SUBJECT_COLORS['PUC I BIOLOGY'];
    if (subjectName.includes('CHEMISTRY')) return SUBJECT_COLORS['PUC II CHEMISTRY'];
    if (subjectName.includes('PHYSICS')) return SUBJECT_COLORS['PUC II PHYSICS'];
    return '#6B7280';
  };

    if (loading) {
  return (
    <div className='dashboard-container'
      style={{
        position: "fixed",
        inset: 0,
   
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "2.5rem 3rem",
          borderRadius: "1.25rem",
          textAlign: "center",
          boxShadow: "0 20px 40px rgba(0,0,0,0.12)",
          border: "1px solid #e5e7eb",
          width: "90%",
          maxWidth: "360px",
          marginLeft:"250px"
        }}
      >
        {/* Spinner */}
        <div
          style={{
            width: "56px",
            height: "56px",
            borderRadius: "50%",
            border: "4px solid #e5e7eb",
            borderTop: "4px solid #3b82f6",
            margin: "0 auto",
            animation: "spin 1s linear infinite",
          }}
        />

        <h3
          style={{
            marginTop: "1rem",
            marginBottom: "0.25rem",
            fontSize: "1.25rem",
            fontWeight: 700,
            color: "#1f2937",
          }}
        >
          Loading 
        </h3>

        <p
          style={{
            fontSize: "0.875rem",
            color: "#64748b",
            marginBottom: "1.5rem",
          }}
        >
          Fetching analytics & insights…
        </p>

        {/* Skeleton */}
        <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
          {["80%", "60%", "90%"].map((w, i) => (
            <div
              key={i}
              style={{
                height: "10px",
                width: w,
                margin: "0 auto",
                borderRadius: "999px",
                background:
                  "linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 37%, #e5e7eb 63%)",
                backgroundSize: "400% 100%",
                animation: "shimmer 1.4s ease infinite",
              }}
            />
          ))}
        </div>

        {/* Inline keyframes */}
        <style>
          {`
            @keyframes spin {
              to { transform: rotate(360deg); }
            }
            @keyframes shimmer {
              0% { background-position: 100% 0; }
              100% { background-position: -100% 0; }
            }
          `}
        </style>
      </div>
    </div>
  );
}

  if (!performanceData) {
    return (
      <div className="dashboard-container">
        <div className="error-state">
          <div className="error-icon">📊</div>
          <h3>No Data Available</h3>
          <p>Unable to load student performance data.</p>
          <button className="retry-button" onClick={fetchData}>
            Retry
          </button>
        </div>
      </div>
    );
  }


  const totalUnanswered =
  overallStats.totalQuestions -
  (overallStats.totalCorrect + overallStats.totalWrong);

  const subjectChartData = subjectWisePerformance.map(subject => ({
    name: subject.subjectName.replace('PUC ', '').trim(),
    accuracy: subject.accuracy,
    correct: subject.totalCorrect,
    wrong: subject.totalWrong,
    unanswered: subject.totalUnanswered,
    total: subject.totalQuestions,
    color: getSubjectColor(subject.subjectName)
  }));

  const chapterChartData = chapterWisePerformance.slice(0, 10).map(chapter => ({
    name: chapter.chapterName.length > 20
      ? chapter.chapterName.substring(0, 20) + '...'
      : chapter.chapterName,
    accuracy: chapter.accuracy || 0,
    correct: chapter.totalCorrect,
    total: chapter.totalQuestions,
    subject: chapter.subjectName.replace('PUC ', '').trim(),
    subjectColor: getSubjectColor(chapter.subjectName)
  }));

  const chaptersBySubject = {};
  chapterWisePerformance.forEach(chapter => {
    const subjectName = chapter.subjectName.replace('PUC ', '').trim();
    if (!chaptersBySubject[subjectName]) {
      chaptersBySubject[subjectName] = [];
    }
    chaptersBySubject[subjectName].push({
      name: chapter.chapterName,
      accuracy: chapter.accuracy || 0,
      correct: chapter.totalCorrect,
      total: chapter.totalQuestions,
      performance: chapter.accuracy >= 70 ? 'Good' : chapter.accuracy >= 50 ? 'Average' : 'Poor'
    });
  });

  const performanceDistribution = [
    { name: 'Correct', value: overallStats.totalCorrect, color: '#10B981' },
    { name: 'Wrong', value: overallStats.totalWrong, color: '#EF4444' },
    { name: 'Unanswered', value: totalUnanswered, color: '#6B7280' }

  ];

  const summaryCards = [
    {
      title: "Total Correct",
      value: overallStats.totalCorrect,
      icon: <FiCheckCircle size={20} />,
      color: "text-green-600",
      iconBg: "bg-green-100"
    },
    {
      title: "Total Wrong",
      value: overallStats.totalWrong,
      icon: <FiXCircle size={20} />,
      color: "text-red-600",
      iconBg: "bg-red-100"
    },
    {
      title: "Total Unanswered",
      value: totalUnanswered,
      icon: <FiHelpCircle size={20} />,
      color: "text-gray-600",
      iconBg: "bg-gray-100"
    },
    {
      title: "Overall Accuracy",
      value: `${Math.round(Number(overallStats.overallAccuracy))}%`,
      icon: <FiTrendingUp size={20} />,
      color: "text-blue-600",
      iconBg: "bg-blue-100"
    },
    {
      title: "Total Questions",
      value: overallStats.totalQuestions,
      icon: <FiFileText size={20} />,
      color: "text-indigo-600",
      iconBg: "bg-indigo-100"
    }
  ];

  return (
    <div className="dashboard-container">
      {/* Header */}
      <div className="dashboard-header">
        <div className="header-content">
         
          <h1>{studentInfo?.first_name || 'Student'}'s Performance Dashboard</h1>
          <p>Roll No.: {studentInfo?.roll} </p>
        </div>
        <div className="header-controls">
          <div className="paper-info">
            <span className="paper-badge">Roll No.</span>
            <span className="paper-name">{studentInfo?.roll}</span>
          </div>

          <select
            value={examLimit}
            onChange={(e) => {
              const selected = e.target.value;
              setExamLimit(selected);
              if (selected === "overall") {
                setExamWiseData([]);
                fetchData();
              } else {
                fetchFilter(Number(selected));
              }
            }}
            className="papers-select"
          >
            <option value="overall">Overall</option>
            <option value={5}>Last 5 Exams</option>
            <option value={10}>Last 10 Exams</option>
            <option value={15}>Last 15 Exams</option>
            <option value={20}>Last 20 Exams</option>
            <option value={25}>Last 25 Exams</option>
            <option value={30}>Last 30 Exams</option>
          </select>
        </div>
      </div>

      {/* Exam-wise Performance */}
      {examWiseData.length > 0 && (
        <div className="dashboard-card full-width">
          <div className="card-header">
            <h2><FiFileText size={18} /> Exam-wise Performance (Last {examLimit} Exams)</h2>
          </div>
          <div className="card-content">
            <div className="exam-grid">
              {examWiseData.map((exam, index) => {
                const accuracy = Math.round(
                  (exam.correctAnswers / exam.totalAnsweredQuestions) * 100
                );
                return (
                  <div key={exam.examId} className="exam-card" onClick={() => navigate(`/paper-overview/${exam.paperId}`)}>
                    <div className="exam-header">
                      <span className="exam-title">{exam.paperName}</span>
                      <span className="exam-status">
                        {accuracy >= 70 ? "Excellent" : accuracy >= 50 ? "Good" : "Needs Work"}
                      </span>
                    </div>
                    <div className="exam-body">
                      <div className="exam-stat">
                        <span>Correct</span>
                        <strong>{exam.correctAnswers}</strong>
                      </div>
                      <div className="exam-stat">
                        <span>Wrong</span>
                        <strong>{exam.wrongAnswers}</strong>
                      </div>
                      <div className="exam-stat">
                        <span>Total</span>
                        <strong>{exam.totalAnsweredQuestions}</strong>
                      </div>
                    </div>
                    <div className="exam-progress">
                      <div className="exam-bar-bg">
                        <div
                          className="exam-bar-fill"
                          style={{
                            width: `${accuracy}%`,
                            background:
                              accuracy >= 70 ? "#10B981" :
                                accuracy >= 50 ? "#F59E0B" : "#EF4444",
                          }}
                        >
                          <span>{accuracy}%</span>
                        </div>
                      </div>
                    </div>
                    <div className="exam-footer">
                      <span>{new Date(exam.startTime).toLocaleDateString()}</span>
                      <span>{exam.highestSubject?.subjectName?.replace("PUC ", "")}</span>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="paper-table-container">
              <table className="paper-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Exam Name</th>
                    <th>Subject</th>
                    <th>Correct</th>
                    <th>Wrong</th>
                    <th>Total</th>
                    <th>Accuracy</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {examWiseData.map((exam, index) => {
                    const accuracy = Math.round(
                      (exam.correctAnswers / exam.totalAnsweredQuestions) * 100
                    );
                    return (
                      <tr key={exam.examId} onClick={() => navigate(`/paper-overview/${exam.paperId}`)}>
                        <td>{index + 1}</td>
                        <td>{exam.paperName}</td>
                        <td>{exam.highestSubject?.subjectName?.replace("PUC ", "")}</td>
                        <td className="text-green-600 font-bold">{exam.correctAnswers}</td>
                        <td className="text-red-600 font-bold">{exam.wrongAnswers}</td>
                        <td>{exam.totalAnsweredQuestions}</td>
                        <td>
                          <div className="accuracy-cell">
                            <div className="accuracy-value">
                              {accuracy}%
                              <div className={`accuracy-dot ${
                                accuracy >= 70 ? "bg-green-500" :
                                accuracy >= 50 ? "bg-yellow-500" : "bg-red-500"
                              }`}></div>
                            </div>
                            <div className="accuracy-bar">
                              <div 
                                className={`accuracy-fill ${
                                  accuracy >= 70 ? "bg-green-500" :
                                  accuracy >= 50 ? "bg-yellow-500" : "bg-red-500"
                                }`}
                                style={{ width: `${accuracy}%` }}
                              ></div>
                            </div>
                          </div>
                        </td>
                        <td>{new Date(exam.startTime).toLocaleDateString()}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* Summary Cards */}
      <div className="summary-grid">
        {summaryCards.map((card, index) => (
          <div key={index} className="summary-card">
            <div className={`summary-icon ${card.iconBg}`}>
              {card.icon}
            </div>
            <div className="summary-content">
              <div className="summary-title">{card.title}</div>
              <div className={`summary-value ${card.color}`}>{card.value}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Quick Performance Card */}
      <div className="charts-grid">
        <div className="chart-card">
          <div className="card-header">
            <h2><FiAward size={18} /> Overall Accuracy</h2>
          </div>
          <div className="card-content">
            <div className="accuracy-display">
              <div style={{ width: '100px', height: '100px' }}>
                <CircularProgressbar
                  value={Math.round(Number(overallStats.overallAccuracy))}
                  text={`${Math.round(Number(overallStats.overallAccuracy))}%`}
                  styles={buildStyles({
                    textSize: '20px',
                    pathColor: overallStats.overallAccuracy >= 70 ? '#10B981' :
                      overallStats.overallAccuracy >= 50 ? '#F59E0B' : '#EF4444',
                    textColor: '#1F2937',
                    trailColor: '#E5E7EB',
                  })}
                />
              </div>
              <div className="accuracy-details">
                <div className="performance-item">
                  <FiCheckCircle color="#10b981" />
                  <div>
                    <span className="stat-label">Correct Answers</span>
                    <span className="stat-number">{overallStats.totalCorrect}</span>
                  </div>
                </div>
                <div className="performance-item">
                  <FiXCircle color="#ef4444" />
                  <div>
                    <span className="stat-label">Wrong Answers</span>
                    <span className="stat-number">{overallStats.totalWrong}</span>
                  </div>
                </div>
                <div className="performance-item">
                  <FiMinusCircle color="#6b7280" />
                  <div>
                    <span className="stat-label">Unanswered</span>
                  <span className="stat-number">{totalUnanswered}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="chart-card">
          <div className="card-header">
            <h2><FiPieChart size={18} /> Performance Distribution</h2>
          </div>
          <div className="card-content">
            <div className="distribution-container">
              <div className="donut-chart">
                <div className="donut-ring">
                  <div className="donut-center"></div>
                  <div className="donut-value">
                    {overallStats.totalQuestions > 0 
                      ? Math.round(overallStats.totalCorrect / overallStats.totalQuestions * 100) 
                      : 0}%
                  </div>
                </div>
              </div>
              <div className="distribution-legend">
                <div className="legend-item">
                  <div className="legend-dot bg-green-500"></div>
                  <span>Correct ({overallStats.totalCorrect})</span>
                </div>
                <div className="legend-item">
                  <div className="legend-dot bg-red-500"></div>
                  <span>Wrong ({overallStats.totalWrong})</span>
                </div>
                <div className="legend-item">
                  <div className="legend-dot bg-gray-300"></div>
                <span>Other ({totalUnanswered})</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="tabs-container">
        <div className="tabs-wrapper">
          <button
            className={`tab-button ${activeTab === 'overview' ? 'active' : ''}`}
            onClick={() => setActiveTab('overview')}
          >
            <FiGrid size={18} />
            <span>Overview</span>
          </button>
          <button
            className={`tab-button ${activeTab === 'subjects' ? 'active' : ''}`}
            onClick={() => setActiveTab('subjects')}
          >
            <FiBook size={18} />
            <span>Subjects</span>
          </button>
          <button
            className={`tab-button ${activeTab === 'chapters' ? 'active' : ''}`}
            onClick={() => setActiveTab('chapters')}
          >
            <FiActivity size={18} />
            <span>Chapters</span>
          </button>
          <button
            className={`tab-button ${activeTab === 'comparison' ? 'active' : ''}`}
            onClick={() => setActiveTab('comparison')}
          >
            <FiUsers size={18} />
            <span>Comparison</span>
          </button>
        </div>
      </div>

      {/* Tab Content */}
      {activeTab === 'overview' && (
        <div className="dashboard-grid">
          {/* Strong Areas */}
          {strongAreas?.chapters?.length > 0 && (
            <div className="dashboard-card">
              <div className="card-header">
                <h2><FiTrendingUp size={18} /> Strong Areas ({strongAreas?.chapters?.length || 0})</h2>
              </div>
              <div className="card-content">
                <div className="areas-grid">
                  {strongAreas?.chapters?.map((area, index) => (
                    <div key={index} className="area-card strong">
                      <div className="area-header">
                        <span className="subject-badge">
                          {area.subjectName.replace('PUC ', '')}
                        </span>
                        <span className="accuracy-badge">
                          {area.accuracy}%
                        </span>
                      </div>
                      <h4>{area.chapterName}</h4>
                      <div className="area-footer">
                        <span>{area.totalCorrect}/{area.totalQuestions} correct</span>
                        <span>Last: {new Date(area.lastAttempted).toLocaleDateString()}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Weak Areas */}
          {weakAreas?.chapters?.length > 0 && (
            <div className="dashboard-card">
              <div className="card-header">
                <h2><FiTarget size={18} /> Weak Areas ({weakAreas?.chapters?.length || 0})</h2>
              </div>
              <div className="card-content">
                <div className="areas-grid">
                  {weakAreas?.chapters?.map((area, index) => (
                    <div key={index} className="area-card weak">
                      <div className="area-header">
                        <span className="subject-badge">
                          {area.subjectName.replace('PUC ', '')}
                        </span>
                        <span className="accuracy-badge poor">
                          {area.accuracy}%
                        </span>
                      </div>
                      <h4>{area.chapterName}</h4>
                      <div className="area-footer">
                        <span>{area.totalCorrect}/{area.totalQuestions} correct</span>
                        <span>Last: {new Date(area.lastAttempted).toLocaleDateString()}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {activeTab === 'subjects' && (
        <div className="dashboard-grid">
          <div className="subject-cards-grid">
            {subjectWisePerformance.map((subject) => (
              <div
                key={subject.subjectId}
                className="subject-card"
              >
                <div className="subject-card-header">
                  <div className="subject-card-avatar" style={{ background: getSubjectColor(subject.subjectName) + '20', color: getSubjectColor(subject.subjectName) }}>
                    {subject.subjectName.replace('PUC ', '').charAt(0)}
                  </div>
                  <div>
                    <h4>{subject.subjectName.replace('PUC ', '')}</h4>
                    <p>{subject.totalQuestions} questions</p>
                  </div>
                </div>

                <div className="subject-stats-grid">
                  <div className="stat-item">
                    <div className="stat-value text-green-600">{subject.totalCorrect}</div>
                    <div className="stat-label">Correct</div>
                  </div>
                  <div className="stat-divider"></div>
                  <div className="stat-item">
                    <div className="stat-value text-red-600">{subject.totalWrong}</div>
                    <div className="stat-label">Wrong</div>
                  </div>
                  <div className="stat-divider"></div>
                  <div className="stat-item">
                    <div className="stat-value text-orange-600">{subject.accuracy}%</div>
                    <div className="stat-label">Accuracy</div>
                  </div>
                  <div className="stat-divider"></div>
                  <div className="stat-item">
                    <div className="stat-value text-gray-600">{subject.totalUnanswered}</div>
                    <div className="stat-label">Unanswered</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="dashboard-card full-width">
            <div className="card-header">
              <h2>📊 Subject-wise Comparison</h2>
            </div>
            <div className="card-content">
              <div style={{ width: '100%', height: '300px' }}>
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart data={subjectChartData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis domain={[0, 100]} />
                    <Tooltip formatter={(value) => [`${value}%`, 'Accuracy']} />
                    <Legend />
                    <Bar dataKey="accuracy" name="Accuracy %" fill="#8884d8" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        </div>
      )}

      {activeTab === 'chapters' && (
        <div className="dashboard-grid">
          <div className="subject-chapters-grid">
            {Object.entries(chaptersBySubject).map(([subjectName, chapters], index) => (
              <div key={index} className="subject-chapter-card">
                <div className="card-header">
                  <h2 style={{ color: getSubjectColor(subjectName) }}>
                    <FiBook size={18} /> {subjectName}
                  </h2>
                </div>
                <div className="card-content">
                  <div style={{ width: '100%', height: '250px' }}>
                    <ResponsiveContainer width="100%" height="100%">
                      <BarChart data={chapters.slice(0, 6)}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                          dataKey="name"
                          angle={-45}
                          textAnchor="end"
                          height={60}
                          interval={0}
                          fontSize={10}
                        />
                        <YAxis domain={[0, 100]} />
                        <Tooltip formatter={(value) => [`${value}%`, 'Accuracy']} />
                        <Bar
                          dataKey="accuracy"
                          name="Accuracy %"
                          fill={getSubjectColor(subjectName)}
                          radius={[4, 4, 0, 0]}
                        />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {activeTab === 'comparison' && (
        <div className="dashboard-grid">
          <div className="dashboard-card">
            <div className="card-header">
              <h2><FiUsers size={18} /> Top 5 Students Comparison</h2>
            </div>
            <div className="card-content">
              <div className="paper-table-container">
                <table className="paper-table">
                  <thead>
                    <tr>
                      <th>Rank</th>
                      <th>Student Name</th>
                      <th>Accuracy</th>
                      <th>Correct</th>
                      <th>Total</th>
                      <th>Marks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {topStudents.map((student, index) => (
                      <tr
                        key={student.student_id}
                        className={student.student_id === id ? 'highlighted-row' : ''}
                      >
                        <td>
                          <div className="student-rank">{index + 1}</div>
                        </td>
                        <td>
                          <div className="student-name">
                            {student.studentName}
                            {student.student_id === id && (
                              <span className="you-badge">(You)</span>
                            )}
                          </div>
                        </td>
                        <td>
                          <div className="accuracy-cell">
                            <div className="accuracy-value">
                              {Math.round(Number(student.overall_accuracy))}%
                              <div className={`accuracy-dot ${
                                parseFloat(student.overall_accuracy) >= 70 ? "bg-green-500" :
                                parseFloat(student.overall_accuracy) >= 50 ? "bg-yellow-500" : "bg-red-500"
                              }`}></div>
                            </div>
                            <div className="accuracy-bar">
                              <div 
                                className={`accuracy-fill ${
                                  parseFloat(student.overall_accuracy) >= 70 ? "bg-green-500" :
                                  parseFloat(student.overall_accuracy) >= 50 ? "bg-yellow-500" : "bg-red-500"
                                }`}
                                style={{ width: `${Math.round(Number(student.overall_accuracy))}%` }}
                              ></div>
                            </div>
                          </div>
                        </td>
                        <td>{student.total_correct}</td>
                        <td>{student.total_questions}</td>
                        <td>{student.total_marks}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="dashboard-card">
            <div className="card-header">
              <h2>📈 Your Performance vs Average</h2>
            </div>
            <div className="card-content">
              <div className="comparison-stats">
                <div className="comparison-item">
                  <span>Your Accuracy</span>
                  <strong>{Math.round(Number(overallStats.overallAccuracy))}%</strong>
                </div>
                <div className="comparison-item">
                  <span>Average Accuracy</span>
                  <strong>45%</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Summary Stats */}
      <div className="dashboard-card full-width">
        <div className="card-header">
          <h2>📊 Performance Summary</h2>
        </div>
        <div className="card-content">
          <div className="summary-grid">
            <div className="summary-card">
              <div className="summary-icon bg-blue-100">
                <FiTrendingUp size={24} />
              </div>
              <div>
                <div className="summary-label">Strong Chapters</div>
                <div className="summary-value text-blue-600">{strongAreas?.chapters?.length || 0}</div>
              </div>
            </div>
            <div className="summary-card">
              <div className="summary-icon bg-red-100">
                <FiTarget size={24} />
              </div>
              <div>
                <div className="summary-label">Weak Chapters</div>
                <div className="summary-value text-red-600">{weakAreas?.chapters?.length || 0}</div>
              </div>
            </div>
            <div className="summary-card">
              <div className="summary-icon bg-green-100">
                <FiBook size={24} />
              </div>
              <div>
                <div className="summary-label">Total Subjects</div>
                <div className="summary-value text-green-600">{overallStats.totalSubjects}</div>
              </div>
            </div>
            <div className="summary-card">
              <div className="summary-icon bg-purple-100">
                <FiBook size={24} />
              </div>
              <div>
                <div className="summary-label">Total Chapters</div>
                <div className="summary-value text-purple-600">{overallStats.totalChapters}</div>
              </div>
            </div>
            <div className="summary-card">
              <div className="summary-icon bg-yellow-100">
                <FiBook size={24} />
              </div>
              <div>
                <div className="summary-label">Total Topics</div>
                <div className="summary-value text-yellow-600">{overallStats.totalTopics}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        /* Base Container */
        .dashboard-container {
          min-height: 100vh;
          background: linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%);
          padding: 1rem;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        }

        /* Loading State */
        .loading-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: 400px;
        }
        
        .loading-spinner {
          width: 40px;
          height: 40px;
          border: 3px solid #e0f2fe;
          border-top: 3px solid #0369a1;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
        
        .loading-text {
          margin-top: 12px;
          color: #64748b;
          font-size: 0.875rem;
        }

        /* Error State */
        .error-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: 400px;
          text-align: center;
          background: white;
          border-radius: 1rem;
          padding: 3rem 2rem;
          box-shadow: 0 4px 6px rgba(0,0,0,0.05);
        }

        .error-icon {
          font-size: 3rem;
          margin-bottom: 1rem;
        }

        .error-state h3 {
          color: #dc2626;
          margin: 0 0 0.5rem;
          font-size: 1.25rem;
        }

        .error-state p {
          color: #6b7280;
          margin-bottom: 1.5rem;
          font-size: 0.875rem;
        }

        .retry-button {
          padding: 0.5rem 1.5rem;
          background: #3b82f6;
          color: white;
          border: none;
          border-radius: 0.5rem;
          font-weight: 500;
          cursor: pointer;
          font-size: 0.875rem;
          transition: background 0.2s;
        }

        .retry-button:hover {
          background: #2563eb;
        }

        /* Header */
        .dashboard-header {
          margin: 0 auto 1.5rem;
          background: white;
          border-radius: 1rem;
          padding: 1.25rem;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
          border: 1px solid #e2e8f0;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          flex-wrap: wrap;
          gap: 1rem;
        }

        .header-content {
          flex: 1;
          min-width: 300px;
        }

        .header-content h1 {
          font-size: 1.5rem;
          font-weight: 700;
          color: #1f2937;
          margin: 0 0 0.5rem;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .header-content p {
          font-size: 0.875rem;
          color: #6b7280;
          margin: 0;
        }

        .header-controls {
          display: flex;
          align-items: center;
          gap: 1rem;
          flex-wrap: wrap;
        }

        .paper-info {
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .paper-badge {
          background: #3b82f6;
          color: white;
          padding: 0.25rem 0.75rem;
          border-radius: 1rem;
          font-size: 0.75rem;
          font-weight: 600;
        }

        .paper-name {
          font-weight: 500;
          color: #374151;
          font-size: 0.875rem;
        }

        .papers-select {
          padding: 0.5rem 0.75rem;
          border-radius: 0.5rem;
          border: 1px solid #e5e7eb;
          font-size: 0.875rem;
          background: white;
          color: #1f2937;
          min-width: 140px;
          font-weight: 500;
          cursor: pointer;
          outline: none;
          transition: border-color 0.2s;
        }

        .papers-select:hover {
          border-color: #cbd5e0;
        }

        /* Summary Cards */
        .summary-grid {
          margin: 0 auto 1.5rem;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 1rem;
        }

        .summary-card {
          background: white;
          border-radius: 0.75rem;
          padding: 1rem;
          display: flex;
          align-items: center;
          gap: 0.75rem;
          border: 1px solid #e2e8f0;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
          transition: all 0.2s;
        }

        .summary-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          border-color: #cbd5e0;
        }

        .summary-icon {
          width: 2.5rem;
          height: 2.5rem;
          border-radius: 0.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .summary-content {
          flex: 1;
        }

        .summary-title {
          font-size: 0.75rem;
          color: #6b7280;
          font-weight: 500;
          margin-bottom: 0.25rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .summary-value {
          font-size: 1.25rem;
          font-weight: 700;
        }

        /* Charts Grid */
        .charts-grid {
          margin: 0 auto 1.5rem;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 1rem;
        }

        .chart-card {
          background: white;
          border-radius: 0.75rem;
          padding: 1.25rem;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
          border: 1px solid #e2e8f0;
        }

        .card-header {
          font-size: 1rem;
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 1rem;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .card-header h2 {
          font-size: 1rem;
          font-weight: 600;
          color: #1f2937;
          margin: 0;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        /* Accuracy Display */
        .accuracy-display {
          display: flex;
          align-items: center;
          gap: 1.5rem;
          flex-wrap: wrap;
        }

        .accuracy-details {
          flex: 1;
          min-width: 200px;
        }

        .performance-item {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          margin-bottom: 0.75rem;
        }

        .stat-label {
          display: block;
          font-size: 0.75rem;
          color: #6b7280;
          margin-bottom: 0.125rem;
        }

        .stat-number {
          font-size: 0.875rem;
          font-weight: 600;
          color: #1f2937;
        }

        /* Distribution Chart */
        .distribution-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1rem;
          padding: 1rem 0;
        }

        .donut-ring {
          width: 120px;
          height: 120px;
          border-radius: 50%;
          background: conic-gradient(
            #10B981 0% ${(overallStats.totalCorrect / overallStats.totalQuestions * 100) || 0}%,
            #EF4444 ${(overallStats.totalCorrect / overallStats.totalQuestions * 100) || 0}% ${((overallStats.totalCorrect + overallStats.totalWrong) / overallStats.totalQuestions * 100) || 0}%,
            #6B7280 ${((overallStats.totalCorrect + overallStats.totalWrong) / overallStats.totalQuestions * 100) || 0}% ${((overallStats.totalCorrect + overallStats.totalWrong + totalUnanswered) / overallStats.totalQuestions * 100) || 0}%
          );
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .donut-center {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background: white;
          position: absolute;
        }

        .donut-value {
          font-size: 1rem;
          font-weight: 600;
          color: #0369a1;
          position: relative;
        }

        .distribution-legend {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
          width: 100%;
        }

        .legend-item {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.75rem;
          color: #475569;
        }

        .legend-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          flex-shrink: 0;
        }

        /* Tabs */
        .tabs-container {
          background: white;
          border-radius: 0.75rem;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
          border: 1px solid #e2e8f0;
          margin-bottom: 1.5rem;
          overflow: hidden;
        }

        .tabs-wrapper {
          display: flex;
          padding: 0.5rem;
          gap: 0.5rem;
          flex-wrap: wrap;
        }

        .tab-button {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.75rem 1rem;
          border: 1px solid #e5e7eb;
          background: white;
          border-radius: 0.5rem;
          font-size: 0.875rem;
          font-weight: 500;
          color: #6b7280;
          cursor: pointer;
          transition: all 0.2s;
          flex: 1;
          min-width: 120px;
          justify-content: center;
        }

        .tab-button:hover {
          background: #f9fafb;
          border-color: #d1d5db;
        }

        .tab-button.active {
          background: #3b82f6;
          color: white;
          border-color: #3b82f6;
          box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);
        }

        /* Dashboard Grid */
        .dashboard-grid {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          margin-bottom: 1.5rem;
        }

        .dashboard-card {
          background: white;
          border-radius: 0.75rem;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
          border: 1px solid #e2e8f0;
          overflow: hidden;
          padding: 20px
        }

        .dashboard-card.full-width {
          width: 100%;
        }

        .card-content {
          padding: 1.25rem;
        }

        /* Areas Grid */
        .areas-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
          gap: 1rem;
        }

        .area-card {
          padding: 1rem;
          border-radius: 0.5rem;
          border-left: 4px solid;
        }

        .area-card.strong {
          background: #f0f9ff;
          border-left-color: #10b981;
        }

        .area-card.weak {
          background: #fef2f2;
          border-left-color: #ef4444;
        }

        .area-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 0.5rem;
        }

        .subject-badge {
          font-size: 0.75rem;
          color: #64748b;
          background-color: #e2e8f0;
          padding: 0.25rem 0.5rem;
          border-radius: 0.25rem;
          font-weight: 500;
        }

        .accuracy-badge {
          font-weight: 600;
          font-size: 0.875rem;
          color: #10b981;
        }

        .accuracy-badge.poor {
          color: #ef4444;
        }

        .area-card h4 {
          margin: 0.5rem 0;
          color: #1e293b;
          font-size: 0.875rem;
          line-height: 1.4;
        }

        .area-footer {
          display: flex;
          justify-content: space-between;
          font-size: 0.75rem;
          color: #64748b;
          margin-top: 0.5rem;
        }

        /* Subject Cards */
        .subject-cards-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 1rem;
        }

        .subject-card {
          background: white;
          border-radius: 0.75rem;
          padding: 1rem;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
          border: 1px solid #e2e8f0;
          cursor: pointer;
          transition: all 0.2s;
        }

        .subject-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          border-color: #cbd5e0;
        }

        .subject-card-header {
          display: flex;
          align-items: center;
          margin-bottom: 1rem;
        }

        .subject-card-avatar {
          width: 2rem;
          height: 2rem;
          border-radius: 0.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 600;
          font-size: 0.875rem;
          margin-right: 0.75rem;
          flex-shrink: 0;
        }

        .subject-card h4 {
          font-size: 0.875rem;
          font-weight: 600;
          color: #1f2937;
          margin: 0 0 0.25rem 0;
        }

        .subject-card p {
          font-size: 0.75rem;
          color: #6b7280;
          margin: 0;
        }

        .subject-stats-grid {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.75rem;
          background: #f9fafb;
          border-radius: 0.5rem;
        }

        .stat-item {
          text-align: center;
          flex: 1;
        }

        .stat-value {
          font-size: 1rem;
          font-weight: 700;
          margin-bottom: 0.25rem;
        }

        .stat-label {
          font-size: 0.6875rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          color: #6b7280;
          font-weight: 500;
        }

        .stat-divider {
          width: 1px;
          height: 1.5rem;
          background: #e5e7eb;
        }

        /* Subject Chapters Grid */
        .subject-chapters-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
          gap: 1rem;
        }

        .subject-chapter-card {
          background: white;
          border-radius: 0.75rem;
          padding: 1rem;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
          border: 1px solid #e2e8f0;
        }

        /* Exam Grid */
        .exam-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 1rem;
          margin-bottom: 1.5rem;
        }

        .exam-card {
          background: white;
          border-radius: 0.75rem;
          padding: 1rem;
          border: 1px solid #e2e8f0;
          box-shadow: 0 2px 4px rgba(0,0,0,0.05);
          transition: all 0.2s;
          cursor: pointer;
        }

        .exam-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0,0,0,0.08);
          border-color: #cbd5e0;
        }

        .exam-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 0.75rem;
        }

        .exam-title {
          font-weight: 600;
          color: #1f2937;
          font-size: 0.875rem;
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .exam-status {
          font-size: 0.75rem;
          padding: 0.25rem 0.5rem;
          border-radius: 0.375rem;
          background: #d1fae5;
          color: #065f46;
          flex-shrink: 0;
        }

        .exam-body {
          display: flex;
          justify-content: space-between;
          margin-bottom: 0.75rem;
        }

        .exam-stat {
          text-align: center;
          flex: 1;
        }

        .exam-stat span {
          font-size: 0.75rem;
          color: #6b7280;
          display: block;
        }

        .exam-stat strong {
          display: block;
          font-size: 0.875rem;
          color: #1f2937;
          margin-top: 0.25rem;
        }

        .exam-progress {
          margin: 0.75rem 0;
        }

        .exam-bar-bg {
          height: 0.5rem;
          background: #e5e7eb;
          border-radius: 0.25rem;
          overflow: hidden;
        }

        .exam-bar-fill {
          height: 100%;
          border-radius: 0.25rem;
          text-align: center;
          font-size: 0.625rem;
          color: white;
          font-weight: 600;
          line-height: 0.5rem;
        }

        .exam-footer {
          display: flex;
          justify-content: space-between;
          margin-top: 0.75rem;
          font-size: 0.75rem;
          color: #6b7280;
        }

        /* Paper Table */
        .paper-table-container {
          background: white;
          border-radius: 0.75rem;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
          overflow: hidden;
          border: 1px solid #e2e8f0;
        }

        .paper-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 0.75rem;
        }

        .paper-table thead {
          background: #f9fafb;
          border-bottom: 2px solid #e5e7eb;
        }

        .paper-table th {
          text-align: left;
          padding: 0.75rem 1rem;
          font-weight: 600;
          color: #374151;
          font-size: 0.75rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .paper-table tbody tr {
          border-bottom: 1px solid #f3f4f6;
          background: white;
          transition: background-color 0.2s;
          cursor: pointer;
        }

        .paper-table tbody tr:hover {
          background-color: #f1f5f9;
        }

        .paper-table td {
          padding: 0.75rem 1rem;
          font-weight: 500;
          color: #1f2937;
        }

        .accuracy-cell {
          display: flex;
          flex-direction: column;
          gap: 0.25rem;
        }

        .accuracy-value {
          display: flex;
          align-items: center;
          gap: 0.375rem;
          color: #0369a1;
          font-weight: 600;
          font-size: 0.75rem;
        }

        .accuracy-dot {
          width: 0.375rem;
          height: 0.375rem;
          border-radius: 50%;
        }

        .accuracy-bar {
          height: 0.25rem;
          background: #f1f5f9;
          border-radius: 0.125rem;
          overflow: hidden;
          width: 4rem;
        }

        .accuracy-fill {
          height: 100%;
          border-radius: 0.125rem;
        }

        .highlighted-row {
          background-color: #eff6ff !important;
          border-left: 4px solid #3b82f6;
        }

        .student-rank {
          width: 1.5rem;
          height: 1.5rem;
          background: #3b82f6;
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 0.75rem;
        }

        .student-name {
          font-weight: 600;
          color: #374151;
          font-size: 0.75rem;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .you-badge {
          background-color: #3b82f6;
          color: white;
          padding: 0.125rem 0.375rem;
          border-radius: 0.25rem;
          font-size: 0.625rem;
        }

        /* Comparison Stats */
        .comparison-stats {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
        }

        .comparison-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.75rem;
          background-color: #f8fafc;
          border-radius: 0.5rem;
          font-size: 0.875rem;
        }

        .comparison-item span {
          color: #64748b;
        }

        .comparison-item strong {
          font-size: 1rem;
          font-weight: 700;
          color: #3b82f6;
        }

        /* Color Utilities */
        .text-green-600 { color: #16a34a; }
        .text-red-600 { color: #dc2626; }
        .text-blue-600 { color: #0369a1; }
        .text-gray-600 { color: #6b7280; }
        .text-indigo-600 { color: #4f46e5; }
        .text-orange-600 { color: #ea580c; }
        .text-purple-600 { color: #7c3aed; }
        .text-yellow-600 { color: #ca8a04; }
        
        .bg-green-100 { background-color: #dcfce7; color: #16a34a; }
        .bg-red-100 { background-color: #fee2e2; color: #dc2626; }
        .bg-gray-100 { background-color: #f3f4f6; color: #4b5563; }
        .bg-blue-100 { background-color: #dbeafe; color: #1d4ed8; }
        .bg-indigo-100 { background-color: #e0e7ff; color: #4f46e5; }
        .bg-purple-100 { background-color: #f3e8ff; color: #7c3aed; }
        .bg-yellow-100 { background-color: #fef9c3; color: #ca8a04; }
        
        .bg-green-500 { background-color: #10B981; }
        .bg-red-500 { background-color: #EF4444; }
        .bg-yellow-500 { background-color: #F59E0B; }
        .bg-gray-300 { background-color: #d1d5db; }
        
        .font-bold { font-weight: 700; }

        /* Responsive Design */
        @media (max-width: 768px) {
          .dashboard-container {
            padding: 0.75rem;
          }
          
          .dashboard-header {
            flex-direction: column;
            gap: 1rem;
          }
          
          .header-content {
            min-width: auto;
          }
          
          .charts-grid {
            grid-template-columns: 1fr;
          }
          
          .summary-grid {
            grid-template-columns: repeat(2, 1fr);
          }
          
          .areas-grid,
          .subject-cards-grid,
          .subject-chapters-grid,
          .exam-grid {
            grid-template-columns: 1fr;
          }
          
          .tabs-wrapper {
            justify-content: center;
          }
          
          .tab-button {
            min-width: calc(50% - 0.5rem);
          }

          .accuracy-display {
            flex-direction: column;
            text-align: center;
          }

          .accuracy-details {
            width: 100%;
          }
        }

        @media (max-width: 480px) {
          .summary-grid {
            grid-template-columns: 1fr;
          }
          
          .tab-button {
            min-width: 100%;
          }
          
          .subject-stats-grid {
            flex-direction: column;
            gap: 0.5rem;
          }
          
          .stat-divider {
            display: none;
          }
          
          .paper-table {
            font-size: 0.6875rem;
          }
          
          .paper-table th,
          .paper-table td {
            padding: 0.5rem 0.75rem;
          }
        }

        @media (min-width: 769px) and (max-width: 1024px) {
          .subject-cards-grid,
          .subject-chapters-grid {
            grid-template-columns: repeat(2, 1fr);
          }
          
          .exam-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default StudentOverall;